import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

const InteractiveLogo = ({ user }) => {
  const navigate = useNavigate();
  const [hoveredZone, setHoveredZone] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    const fetchUnread = async () => {
      try {
        const res = await axios.get(`${API}/messages/unread-count`);
        setUnreadCount(res.data.unread || 0);
      } catch {}
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);
    return () => clearInterval(interval);
  }, [user]);

  const zones = [
    { id: 'heart', label: 'Vitals', path: '/vitals', area: { top: '18%', left: '32%', width: '14%', height: '20%' }, color: 'rgba(239,68,68,0.3)' },
    { id: 'yellow', label: `Messages${unreadCount > 0 ? ` (${unreadCount})` : ''}`, path: '/messages', area: { top: '4%', left: '44%', width: '12%', height: '20%' }, color: 'rgba(234,179,8,0.3)' },
    { id: 'check', label: 'Dashboard', path: '/dashboard', area: { top: '26%', left: '42%', width: '16%', height: '22%' }, color: 'rgba(255,215,0,0.25)' },
    { id: 'green', label: 'Resources', path: '/resources', area: { top: '18%', left: '54%', width: '14%', height: '20%' }, color: 'rgba(34,197,94,0.3)' },
    { id: 'text', label: 'Help Center', path: '/help', area: { top: '62%', left: '10%', width: '80%', height: '20%' }, color: 'rgba(59,130,246,0.2)' },
  ];

  const handleClick = (zone) => {
    if (user) {
      navigate(zone.path);
    } else {
      navigate('/auth');
    }
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }} data-testid="interactive-logo">
      <img
        src="/careguard-logo-full.jpg"
        alt="CareGuard"
        className="landing-logo"
        data-testid="landing-logo"
      />
      {zones.map(zone => (
        <div
          key={zone.id}
          onClick={() => handleClick(zone)}
          onMouseEnter={() => setHoveredZone(zone.id)}
          onMouseLeave={() => setHoveredZone(null)}
          data-testid={`logo-zone-${zone.id}`}
          style={{
            position: 'absolute',
            top: zone.area.top,
            left: zone.area.left,
            width: zone.area.width,
            height: zone.area.height,
            borderRadius: zone.id === 'text' ? '8px' : '50%',
            cursor: 'pointer',
            background: hoveredZone === zone.id ? zone.color : 'transparent',
            transition: 'all 0.3s ease',
            zIndex: 2,
          }}
        >
          {/* Unread badge on yellow/messages zone */}
          {zone.id === 'yellow' && unreadCount > 0 && (
            <div style={{
              position: 'absolute', top: '-6px', right: '-6px',
              background: '#ef4444', color: '#fff', borderRadius: zone.id === 'text' ? '8px' : '50%',
              width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '0.7rem', fontWeight: '700', border: '2px solid #fff',
              boxShadow: '0 2px 6px rgba(0,0,0,0.3)', zIndex: 3
            }} data-testid="unread-badge">
              {unreadCount}
            </div>
          )}
          {hoveredZone === zone.id && (
            <span style={{
              position: 'absolute',
              bottom: zone.id === 'text' ? '-28px' : '-24px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: 'rgba(0,0,0,0.8)',
              color: '#fff',
              padding: '4px 12px',
              borderRadius: '6px',
              fontSize: '0.8rem',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              pointerEvents: 'none',
              zIndex: 10,
            }}>
              {zone.label}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default InteractiveLogo;
